<template>
<div>
  <shot-quality :game_id="this.gameId" :home_name="this.gameInfo.home_team.name" :away_name="this.gameInfo.away_team.name"></shot-quality>
  <!-- <shot-diff-time :gameId=this.gameId :home_name="this.gameInfo.home_team.name" :away_name="this.gameInfo.away_team.name"></shot-diff-time> -->
  <shots-heatmap :gameId="this.gameId" :home_name="this.gameInfo.home_team.name" :away_name="this.gameInfo.away_team.name"></shots-heatmap>
</div>
</template>
<script>
import ShotDiffTime from './shot-diff-time.vue'
import ShotQuality from './shots-quality.vue'
import ShotsHeatmap from './shots-heatmap.vue'
export default {
  props: {
    gameId: { type: Number, required: true },
    period: { type: Number, required: true },
    gameInfo: { type: Object, required: true }
  },
  components: {
    'shot-diff-time': ShotDiffTime,
    'shot-quality': ShotQuality,
    'shots-heatmap': ShotsHeatmap
  },
  data () {
    return {
    }
  },
  computed: {

  },
  watch: {
    endpoint: {
      handler: function (endpoint) {
        this.url = endpoint
      },
      immediate: true
    },
    gameId: {
      handler: function (postData) {
        // console.log('Post data updated: ' + JSON.stringify(this.postData))
      },
      immediate: true
    }
  },
  methods: {
    gameDataLoaded () {
    // console.log('Shots Loaded')
    }
  },
  mounted: function () {
  }
}
</script>
<style lang='scss' scoped>

.segment {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.small-box {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 100%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.segment h1 {
  color: black;
  text-shadow: 0px 1px 1px #8b0505d1;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-top:0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}
.segment h2 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 2em;
}
.segment p{
  font-size:1.2em;
  text-transform: uppercase;
}
.stat-title{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.3rem;
  margin: 1rem 0rem;
}
.stat-category{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.5rem;
  margin: 1rem 0rem;
}
.stat-number{
  font-family: 'Heebo', sans-serif;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.3rem;
  margin: 1rem 0rem;
  color:black;
}
</style>



// WEBPACK FOOTER //
// match-shots.vue?b3288cf2